import React from "react";
import { SectionBlock } from "../../components/light/SectionBlock";
import moment from "moment";
import { gql, useQuery } from "@apollo/client";
import { BreadCrumb, BreadCrumbProp } from "../../components/light/Breadcrumb";
import { Link } from "react-router-dom";

const query_merchant_product_view_date = gql`
  query merchantProductViewDate($from: String!, $to: String!, $itemsID: [Int]) {
    merchantProductViewDate(from: $from, to: $to, itemsID: $itemsID)
  }
`;

type Props = {
  history: any;
};

const now = moment(new Date()).format("YYYY-MM-DD");
const seven_day = moment(new Date().setDate(new Date().getDate() - 7)).format("YYYY-MM-DD");

const BreadCrumbItems: BreadCrumbProp[] = [
  {
    text: "Dashboard",
    to: "/",
  },
  {
    text: "Analytics",
    to: "/analytics",
  },
];

export class AnalyticsScreen extends React.Component<Props> {
  state: {
    from: string;
    to: string;
    itemsID: number[];
    fromInput: string;
    toInput: string;
    items: any[];
    itemsDisplay: any[];
    checkAll: boolean;
    searchInput: string;
    sales: any[];
    clicks: any[];
    views: any[];
  };

  constructor(props: Props) {
    super(props);
    const query = new URLSearchParams(window.location.search);
    if (query.get("from") === null || query.get("to") === null) {
      this.props.history.push(`/analytics?from=${seven_day}&to=${moment(now).format("YYYY-MM-DD")}`);
    }
    this.state = {
      from: query.get("from")! === null ? seven_day : query.get("from")!,
      to: query.get("to")! === null ? now : query.get("to")!,
      itemsID: [],
      fromInput: query.get("from")! === null ? seven_day : query.get("from")!,
      toInput: query.get("to")! === null ? now : query.get("to")!,
      items: [],
      checkAll: false,
      searchInput: "",
      itemsDisplay: [],
      sales: [],
      clicks: [],
      views: [],
    };
  }

  onCompleteProduct = (data: any) => {
    if (this.state.items.length > 0) {
      const items = data.merchantProductView.map((x: any) => {
        const checked = this.state.items.find((i) => i.itemid === x.itemid).checked;
        return {
          ...x,
          checked: checked,
        };
      });

      this.setState({ items, itemsDisplay: items });
    } else {
      const itemsID: any[] = [];
      const items = data.merchantProductView.map((x: any) => {
        itemsID.push(x.itemid);
        return {
          ...x,
          checked: true,
        };
      });

      this.setState({ items, itemsDisplay: items, checkAll: true, itemsID });
    }
  };

  onCheckedAll = async () => {
    const items = this.state.items;
    const itemsDisplay = this.state.itemsDisplay;
    await this.setState({
      checkAll: !this.state.checkAll,
    });
    if (this.state.checkAll === true) {
      items.map((x) => (x.checked = true));
      itemsDisplay.map((x) => (x.checked = true));
    } else {
      items.map((x) => (x.checked = false));
      itemsDisplay.map((x) => (x.checked = false));
    }
    await this.setState({ items, itemsDisplay });
  };

  onClickFilter = () => {
    const itemsID: any[] = [];
    for (const x of this.state.items) {
      if (x.checked === true) {
        itemsID.push(x.itemid);
      }
    }
    this.setState({
      from: this.state.fromInput,
      to: this.state.toInput,
      itemsID,
    });
    this.props.history.push(`/analytics?from=${this.state.fromInput}&to=${this.state.toInput}`);
  };

  onChangeSearch = (e: any) => {
    this.setState({
      searchInput: e.target.value,
    });
  };

  onKeyDown = (e: any) => {
    const items = this.state.items;
    if (e.keyCode === 13) {
      if (this.state.searchInput !== "") {
        this.setState({
          itemsDisplay: items.filter((x) => x.code <= this.state.searchInput),
        });
      } else {
        this.setState({
          itemsDisplay: items,
        });
      }
    }
  };

  onQueryLine = (data: any) => {
    const clicked = data.merchantProductViewDate.map((d: any) => {
      return {
        x: d.viewed_date,
        y: d.Clicked,
      };
    });
    const sales = data.merchantProductViewDate.map((d: any) => {
      return {
        x: d.viewed_date,
        y: d.Sales,
      };
    });
    const views = data.merchantProductViewDate.map((d: any) => {
      return {
        x: d.viewed_date,
        y: 0,
      };
    });
    const saleItems = [
      {
        id: "Sales",
        data: sales,
      },
    ];
    const clicksItems = [
      {
        id: `Clicked`,
        data: clicked,
      },
    ];
    const viewsItems = [
      {
        id: "Views",
        data: views,
      },
    ];
    this.setState({
      sales: saleItems,
      clicks: clicksItems,
      views: viewsItems,
    });
  };

  render() {
    return (
      <div className="content-w">
        <BreadCrumb items={BreadCrumbItems} />
        <div className="content-i">
          <div className="content-box" style={{ height: window.innerHeight - 54, overflowY: "auto" }}>
            {this.renderFormFilter()}
            <br />
            <SectionBlock title="Product Sales">
              <div
                style={{
                  height: window.innerHeight / 4,
                  width: "100%",
                }}
              >
                {/* {this.renderResponsiveLine(this.state.sales, "nivo")} */}
              </div>
            </SectionBlock>
            <SectionBlock title="Product Clicked">
              <div
                style={{
                  height: window.innerHeight / 4,
                  width: "100%",
                }}
              >
                {/* {this.renderResponsiveLine(this.state.clicks, "category10")} */}
              </div>
            </SectionBlock>
          </div>
          {this.renderContentPanel()}
        </div>
      </div>
    );
  }

  renderContentPanel() {
    return (
      <div
        className="content-panel compact color-scheme-light"
        style={{ height: window.innerHeight - 54, overflowY: "auto" }}
      >
        {this.renderElementWrapperProduct()}
      </div>
    );
  }

  renderElementWrapperProduct() {
    return (
      <div className="element-wrapper">
        <div className="element-actions actions-only">
          <Link className="element-action element-action-fold" to="#">
            <i className="os-icon os-icon-minus-circle"></i>
          </Link>
        </div>
        <h6 className="element-header">Product</h6>
        <div className="element-box-tp">
          <input
            type="text"
            placeholder="Search by L192 code"
            className="form-control"
            value={this.state.searchInput}
            onChange={this.onChangeSearch}
            onKeyDown={this.onKeyDown}
          />
          <br />
          <RenderQueryProductView from={this.state.from} to={this.state.to} onCompleteQuery={this.onCompleteProduct}>
            <RenderQueryReport
              from={this.state.from}
              to={this.state.to}
              itemsID={this.state.itemsID}
              onQueryLine={this.onQueryLine}
            />
            <table className="table table-compact smaller text-faded mb-0">
              <thead>
                <tr>
                  <th className="text-left">
                    <input type="checkbox" checked={this.state.checkAll} onChange={this.onCheckedAll} />
                  </th>
                  <th>Code</th>
                  <th>Clicked</th>
                  <th className="text-right">Sales</th>
                </tr>
              </thead>
              <tbody>
                {this.state.itemsDisplay.map((x: any, i: number) => {
                  return (
                    <tr key={x.itemid}>
                      <td className="text-left">
                        <input
                          type="checkbox"
                          checked={x.checked}
                          onChange={(e) => {
                            const itemsDisplay = this.state.itemsDisplay;
                            const items = this.state.items;
                            const index = items.findIndex((i) => i.itemid === x.itemid);
                            itemsDisplay[i].checked = !x.checked;
                            items[index].checked = x.checked;
                            this.setState({ itemsDisplay, items });
                          }}
                        />
                      </td>
                      <td>
                        <Link to={"https://www.l192.com/product/" + x.itemid} target="_blank">
                          <img
                            src={x.thumb_small}
                            alt=""
                            style={{
                              width: 50,
                              height: 65,
                              borderRadius: 2,
                            }}
                          />
                        </Link>
                      </td>
                      <td className="text-center">
                        <span className="text-success">{x.Clicked}</span>
                      </td>
                      <td className="text-right">
                        <span className="text-success">{x.Sales} USD</span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </RenderQueryProductView>
        </div>
      </div>
    );
  }

  renderFormFilter() {
    return (
      <form className="controls-above-table">
        <div className="row">
          <div className="col-sm-12">
            <div className="form-inline justify-content-sm-start">
              <label>From</label>
              <input
                type="text"
                className="form-control form-control-sm rounded bright"
                placeholder="YYYY-MM-DD"
                value={this.state.fromInput}
                onChange={(e) => this.setState({ fromInput: e.target.value })}
              />
              <label>To</label>
              <input
                type="text"
                className="form-control form-control-sm rounded bright"
                placeholder="YYYY-MM-DD"
                value={this.state.toInput}
                onChange={(e) => this.setState({ toInput: e.target.value })}
              />
              <button type="button" className="btn btn-primary btn-sm" onClick={this.onClickFilter}>
                <i className="os-icon os-icon-refresh-ccw"></i>
                <span>Filter Now</span>
              </button>
            </div>
          </div>
        </div>
        <div className="col-2"></div>
      </form>
    );
  }

  /*
  renderResponsiveLine(data: any[], scheme: any) {
    if (data.length > 0) {
      return (
        <ResponsiveLine
          animate={true}
          data={data}
          curve="monotoneX"
          margin={{
            top: 50,
            right: 130,
            bottom: 50,
            left: 60,
          }}
          yScale={{
            type: "linear",
            min: "auto",
            max: "auto",
            stacked: true,
            reverse: false,
          }}
          xScale={{
            type: "point",
          }}
          axisBottom={{
            orient: "bottom",
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: "Date",
            legendOffset: 36,
            legendPosition: "middle",
          }}
          axisLeft={{
            orient: "left",
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: "",
            legendOffset: -40,
            legendPosition: "middle",
          }}
          colors={{ scheme }}
          pointSize={10}
          pointColor={{ theme: "background" }}
          pointBorderWidth={2}
          pointBorderColor={{ from: "serieColor" }}
          pointLabel="y"
          pointLabelYOffset={-12}
          useMesh={true}
          legends={[
            {
              anchor: "bottom-right",
              direction: "column",
              justify: false,
              translateX: 100,
              translateY: 0,
              itemsSpacing: 0,
              itemDirection: "left-to-right",
              itemWidth: 80,
              itemHeight: 50,
              itemOpacity: 0.75,
              symbolSize: 12,
              symbolShape: "circle",
              symbolBorderColor: "rgba(0, 0, 0, .5)",
              effects: [
                {
                  on: "hover",
                  style: {
                    itemBackground: "rgba(0, 0, 0, .03)",
                    itemOpacity: 1,
                  },
                },
              ],
            },
          ]}
          enableSlices={false}
          enableGridX={true}
          theme={{
            axis: { ticks: { text: { fontSize: 10 } } },
            grid: { line: { stroke: "#ddd", strokeDasharray: "1 2" } },
          }}
        />
      );
    }
  }*/
}

function RenderQueryReport({
  from,
  to,
  itemsID,
  onQueryLine,
}: {
  from: string;
  to: string;
  itemsID: number[];
  onQueryLine: any;
}) {
  const { data, loading } = useQuery(query_merchant_product_view_date, {
    fetchPolicy: "no-cache",
    variables: {
      from,
      to,
      itemsID,
    },
    onCompleted: (res) => onQueryLine(res),
  });

  if (data === undefined || loading) {
    return <div></div>;
  }

  return <div></div>;
}

function RenderQueryProductView({
  from,
  to,
  onCompleteQuery,
  children,
}: {
  from: string;
  to: string;
  onCompleteQuery: any;
  children: any;
}) {
  const { data, loading } = useQuery(
    gql`
      query merchantProductView($from: String!, $to: String!) {
        merchantProductView(from: $from, to: $to)
      }
    `,
    {
      fetchPolicy: "no-cache",
      variables: {
        from,
        to,
      },
      onCompleted: (res) => onCompleteQuery(res),
    },
  );

  if (data === undefined || loading) {
    return <div></div>;
  }

  return <div>{children}</div>;
}
